import { useEffect, useMemo, useState } from "react";

import { useGetProductShippingDetails } from "@/Apollo/hooks/product/useGetProductShippingDetails";
import {
  DeliveryAddressInput,
  MeQuery_me_Member_merchants_Merchant_addresses_Address,
  GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2 as ProductShippingOptionV2,
} from "@/Apollo/schema";

export const useProductDeliveryOptionItemList = (
  productId: string,
  address?: MeQuery_me_Member_merchants_Merchant_addresses_Address
) => {
  /** We cache the data returned, so that each new fetch doesn't result in UI that dissapears for a second. */
  const [optionsCache, setOptionsCache] = useState<
    ProductShippingOptionV2[] | null
  >(null);

  const deliveryAddress = useMemo<DeliveryAddressInput | undefined>(() => {
    if (address?.id) {
      return {
        line1: address.line1,
        postal_code: address.postal_code,
        city: address.city,
        countryCode: address.country,
      };
    }
  }, [address]);

  const { data, loading, error } = useGetProductShippingDetails({
    variables: {
      input: {
        product: {
          id: productId,
        },
        deliveryAddress: {
          address: deliveryAddress,
        },
        includeUnsupported: false,
      },
    },
  });

  const shippingOptions =
    data?.getProductShippingDetailsV2.shippingOptions ?? null;

  useEffect(() => {
    if (!loading) {
      setOptionsCache(shippingOptions);
    }
  }, [loading, shippingOptions]);

  return {
    options: optionsCache,
    loading,
    error,
  };
};
